// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-category{
    width: 90%;
    margin: auto;
}
.thead-dark tr{
    /* border-radius: 15px; */
}

/* Add this to your CSS or stylesheets */
.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
  
  .pagination-btn {
    background-color: #040420;
    color: white;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 25px;
    margin: 0 4px;
    font-weight: bold;
    transition: background-color 0.3s ease;
  }
  .pagination-btn.active {
    /* Styles for the active page number button */
    background-color: white;
    color: #000;
    border-color: #007bff;
  }
  .pagination-btn:hover {
    background-color: #ddd;
  }
  
  .current-page {
    font-size: 18px;
    font-weight: bold;
    margin: 0 10px;
    color: #555;
  }
  .action-button {
    background: none;
    border: none;
    cursor: pointer;
    margin-right: 10px;
  }
  
  .action-button:focus {
    outline: none;
  }
  /* .table .thead-dark th {
    color: #fff;
    background-color: #343a40;
    border-color: #454d55;
} */
table .thead-dark th {
  color: #fff;
  /* background: linear-gradient(45deg, #0d0d42e0, black)!important; */
  background-color: #040420 !important;
  /* border-color: #0d0d42e0; */
}`, "",{"version":3,"sources":["webpack://./src/Component/Dashboard/category/category.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,sCAAsC;EACxC;EACA;IACE,6CAA6C;IAC7C,uBAAuB;IACvB,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;EACA;;;;GAIC;AACH;EACE,WAAW;EACX,oEAAoE;EACpE,oCAAoC;EACpC,6BAA6B;AAC/B","sourcesContent":[".manage-category{\n    width: 90%;\n    margin: auto;\n}\n.thead-dark tr{\n    /* border-radius: 15px; */\n}\n\n/* Add this to your CSS or stylesheets */\n.pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n  }\n  \n  .pagination-btn {\n    background-color: #040420;\n    color: white;\n    border: none;\n    padding: 8px 12px;\n    cursor: pointer;\n    border-radius: 25px;\n    margin: 0 4px;\n    font-weight: bold;\n    transition: background-color 0.3s ease;\n  }\n  .pagination-btn.active {\n    /* Styles for the active page number button */\n    background-color: white;\n    color: #000;\n    border-color: #007bff;\n  }\n  .pagination-btn:hover {\n    background-color: #ddd;\n  }\n  \n  .current-page {\n    font-size: 18px;\n    font-weight: bold;\n    margin: 0 10px;\n    color: #555;\n  }\n  .action-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    margin-right: 10px;\n  }\n  \n  .action-button:focus {\n    outline: none;\n  }\n  /* .table .thead-dark th {\n    color: #fff;\n    background-color: #343a40;\n    border-color: #454d55;\n} */\ntable .thead-dark th {\n  color: #fff;\n  /* background: linear-gradient(45deg, #0d0d42e0, black)!important; */\n  background-color: #040420 !important;\n  /* border-color: #0d0d42e0; */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
